export default {"src":"/_next/static/media/swimming-pool.964a91b7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};